// extracted by mini-css-extract-plugin
export default {"container":"Description-module__container__X7KkqCg","compact":"Description-module__compact__XSjqexq"};